import APIClient from '@/shared/http/clients/api'

const resourceName = 'permission'
const APIAccess = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIAccess}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIAccess}/${resourceName}`, data, config)

const PermissionRepository = {
  GetAll,
  Create
}

export default PermissionRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/permission.js